module.exports = __webpack_public_path__ + "img/slider3.c116ee3a.jpg";